export default __webpack_public_path__ + "static/fa-solid-900-8c4a67078d7fcc07fb0e0bbffb022a5c.svg";